export default __webpack_public_path__ + "static/media/lead.4904a4c9.png";